import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopProfileTop728x90Gak from './gak/DesktopProfileTop728x90';
import DesktopProfileTop728x90Hashtag from './hashtag/DesktopProfileTop728x90';
const DesktopProfileTop728x90 = ({ safety = 'off', safetyState })=>{
    const isHashtag = useFlag('ads_prebid');
    if (isHashtag) {
        return /*#__PURE__*/ React.createElement(DesktopProfileTop728x90Hashtag, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopProfileTop728x90Gak, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopProfileTop728x90.displayName = 'DesktopProfileTop728x90';
export default DesktopProfileTop728x90;
